<template>
  <div v-if="!link" class="px-4 py-12">
    <h2 class="text-2xl text-center mb-6=">Nothing happened</h2>
    <div class="flex justify-center items-center my-12">
      <base-button
        @click="$router.push({ name: 'create-link' })"
        theme="gray"
        class="mx-4"
      >
        Create a link
      </base-button>
      <router-link :to="{ name: 'dashboard-links' }" class="mx-4">
        Return to dashboard
      </router-link>
    </div>
  </div>
  <div v-else class="px-4 py-12">
    <h2 class="flex items-center justify-center text-2xl text-green-400 mb-6">
      <icon-check class="mr-2" />
      Link created!
    </h2>
    <DashboardLinksItem :link="link" />

    <div class="flex justify-center items-center my-12">
      <base-button
        @click="$router.push({ name: 'create-link' })"
        theme="gray"
        class="mx-4"
      >
        Create another link
      </base-button>
      <router-link :to="{ name: 'dashboard-links' }" class="mx-4">
        Return to dashboard
      </router-link>
    </div>
  </div>
</template>

<script>
import DashboardLinksItem from '@/views/DashboardLinks/components/DashboardLinksItem';

export default {
  components: {
    DashboardLinksItem,
  },
  computed: {
    link() {
      return this.$route.params.link;
    },
  },
};
</script>
